import { REPORT_STATUS } from "../enums/ReportStatus";
import { REPORT_TYPES } from "../enums/ReportTypes";

export const getReportStatusName = (status) => {
  switch (status) {
    case REPORT_STATUS.PENDING:
      return "Pendiente";
    case REPORT_STATUS.REVIEWED:
      return "Revisado";
    case REPORT_STATUS.DISMISSED:
      return "Omitido";
    default:
      return "";
  }
};

export const getReportTypeName = (type) => {
  switch (type) {
    case REPORT_TYPES.IRRELEVANT_CONTENT:
      return "Contenido irrelevante";
    case REPORT_TYPES.SPAM:
      return "Spam";
    case REPORT_TYPES.OBSCENE_CONTENT:
      return "Lenguaje obsceno";
    case REPORT_TYPES.HATE_SPEECH:
      return "Discriminación o incitación al odio";
    default:
      return "";
  }
};
